export default "__VITE_ASSET__CAnW8esT__"